import React from 'react';
import DOMPurify from 'dompurify';

const TypeOfSecuritySection = ({ incidentSecurity }) => {
  let parsedIncidentSecurity = [];

  try {
    parsedIncidentSecurity = JSON.parse(incidentSecurity || '[]');
  } catch (error) {
    parsedIncidentSecurity = [];
  }

  if (!Array.isArray(parsedIncidentSecurity) || parsedIncidentSecurity.length === 0) {
    return null;
  }

  return (
    <div className="container ">
      <h6 className=" text-dark mt-2">Types Of Security</h6>
      <div className="col-12 ">
        {parsedIncidentSecurity.map((item, key) => (
          <div className="row  px-3 " key={key}>
            <div className="col-12 mb-2">
              <div className="row ">
                <div className="col-12 col-md-12 col-lg-12 mt-2 pt-1 ">
                  <label htmlFor="" className="new-summary">Types Of Security</label>
                  <div
                    className="readonlyColor "
                    style={{
                      border: '1px solid #ccc',
                      borderRadius: '4px',
                      padding: '10px',
                      backgroundColor: '#f9f9f9',
                      lineBreak: 'anywhere',
                    }}
                    dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(item.Security_Description) }}
                  />
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TypeOfSecuritySection;
